export { default } from './ShareCta';
